function getInitials(firstName, lastName) {
  return firstName[0].toUpperCase() + lastName[0].toUpperCase();
}

export { getInitials }
